import * as Sentry from '@sentry/react'

const dsn = process.env.REACT_APP_SENTRY_DSN
const enabled = !!dsn && process.env.NODE_ENV !== 'test'

export const initErrorTracking = (): void => {
    if (!enabled) return
    try {
        Sentry.init({
            dsn,
            environment: process.env.REACT_APP_ENVIRONMENT || 'development',
            release: process.env.REACT_APP_RELEASE_DATE,
            tracesSampleRate: 0,
            autoSessionTracking: false,
            integrations: [Sentry.breadcrumbsIntegration({ console: true, dom: true, fetch: true, history: true, xhr: true })],
            beforeSend: (event) => {
                if (event.exception?.values?.some((ex) => ex.value?.includes("Unexpected token '<'"))) return null
                return event
            },
        })
        Sentry.setTag('service', 'gluon')
    } catch (err) {
        console.error('[errorTracking] init failed', err)
    }
}
